import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from "react-router-dom";
import { clockContex } from '../../../pages/TrainReading/PushUpTimer2/PushUpTimer2';
import dataContext from '../../../context/dataContext';
import mainContext from '../../../context/mainContext';
import audioPlayer from '../../api/audioPlayerWrapper'
import { PitchShifter } from '../../../dist/soundtouch';
// import { PitchShifter } from './soundtouch.js';
const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
const gainNode = audioCtx.createGain();
let shifter;
let timeCounterInSeconds = 0;
const sundtouchIsOn = false;



const loadSource = function (url, tempo) {
    return new Promise((resolve, reject) => {

        if (shifter) {
            shifter.off();
        }
        fetch(url)
            .then((response) => response.arrayBuffer())
            .then((buffer) => {
                console.log('have array buffer');
                audioCtx.decodeAudioData(buffer, (audioBuffer) => {
                    console.log('decoded the buffer');
                    shifter = new PitchShifter(audioCtx, audioBuffer, 16384);
                    shifter.tempo = tempo;
                    shifter.pitch = "1.0";
                    shifter.on('play', (detail) => {
                        console.log("🚀 ~ shifter.on ~ detail:", detail)
                        console.log(`timeplayed: ${detail.timePlayed}`);
                        console.log("🚀 ~ shifter.on ~ detail.formattedTimePlayed:", detail.formattedTimePlayed)
                        console.log("🚀 ~ shifter.on ~ detail.percentagePlayed:", detail.percentagePlayed)
                    });
                    console.log("🚀 ~ audioCtx.decodeAudioData ~ shifter.formattedDuration:", shifter.formattedDuration);
                    resolve(shifter.formattedDuration)
                    // playBtn.removeAttribute('disabled');
                });
            }).catch((err) => {
                console.log("🚀 ~ .then ~ err:", err)
                reject(err);
            });
    });
};

let is_playing = false;
const playAUD = function () {
    console.log(shifter)
    shifter.connect(gainNode);
    gainNode.connect(audioCtx.destination);
    audioCtx.resume().then(() => {
        is_playing = true;
        // this.setAttribute('disabled', 'disabled');
    });
};

const pauseAUD = function (playing = false) {
    shifter.disconnect();
    is_playing = playing;
};
const increaseRateAUD = function (increase) {
    console.log("🚀 ~ increaseRateAUD ~ increase:", increase)
    shifter.tempo = increase;
}
function AudioChangeRate(props) {
    const [loadSoundtouchAudioFile, setLoadSoundtouchAudioFile] = useState(false);
    const [isiPhone, setisiPhone] = useState(window.buildType == "iPhone");
    const [intervalID, setIntervalID] = useState(0)
    const { userDetails } = useContext(dataContext);
    const { TR_duration } = useContext(mainContext);
    const { play, setPlay } = useContext(clockContex);
    const location = useLocation();
    const navigateObject = location.state.navigateObject;
    const [lpm, setLpm] = useState(navigateObject.lpm);
    const [loading, setLoading] = useState(false);
    const [lpmFileNum, setLpmFileNum] = useState(() => pickFile(lpm));
    const [increaseTH, setIncreaseTH] = useState(() => 1.125);
    const [initialTempo, setInitialTempo] = useState(1.0 * lpm / lpmFileNum);
    const [increaseRate, setIncreaseRate] = useState(Math.abs((initialTempo * increaseTH) - initialTempo) / TR_duration);
    const [isPlaying, setIsPlaying] = useState(false);
    // Refs for the audio element
    const audioRef = useRef(null);

    useEffect(() => {
        if (!play) {
            if (!isPlaying) {
                handlePlay();
            } else {
                handlePause();
            }
        }
        if (play) {
            handleResume();
        }
    }, [play]);

    const handlePlay = () => {
        setLoading(true);
        if (window.cordovaOn) {
            // Cordova-based logic
            audioPlayer.play(`wush_${lpmFileNum}_6min`).then(() => {
                setIsPlaying(true);
                setPlay(true);
            }).catch(err => console.error(err)).finally(() => {
                setLoading(false);
            });
            // Web-based logic
        } else if (isiPhone) {
            if (!loadSoundtouchAudioFile) {

                loadSource(`../../../../audio/wush_${lpmFileNum}_6min.mp3`, initialTempo).then(() => {
                    playAUD();
                    setLoadSoundtouchAudioFile(true);
                    setIsPlaying(true);
                    setPlay(true);

                }).catch(err => console.error(err)).finally(() => {
                    setLoading(false);
                });
            } else {
                playAUD();
                setIsPlaying(true);
                setPlay(true);
            }
        } else {
            const audioElement = audioRef.current;
            if (audioElement) {
                audioElement.play();
                audioElement.playbackRate = initialTempo;
                setIsPlaying(true);
                setPlay(true);
                // startTempoIncrease();
            }
        }


    };

    const handlePause = () => {
        if (window.cordovaOn) {
            // Cordova-based logic
            audioPlayer.pause().then(() => {
                setIsPlaying(false);
                props.setDataNewLpm(lpmFileNum * initialTempo);
            }).catch(err => console.error(err));
        } else {
            // Web-based logic
            if (isiPhone) {
                pauseAUD();
                setIsPlaying(false);
            } else {

                const audioElement = audioRef.current;
                if (audioElement) {
                    audioElement.pause();
                    setIsPlaying(false);
                }
            }
        }
    };

    const handleResume = () => {
        if (window.cordovaOn) {
            // Cordova-based logic
            audioPlayer.resume().then(() => {
                setIsPlaying(true);
            }).catch(err => console.error(err));
        } else {
            // Web-based logic
            if (isiPhone) {
                playAUD();
                setIsPlaying(true);
            } else {

                const audioElement = audioRef.current;
                if (audioElement) {
                    audioElement.play();
                    setIsPlaying(true);
                }
            }
        }
    };

    const handleStop = () => {
        if (window.cordovaOn) {
            // Cordova-based logic
            audioPlayer.stop().then(() => {
                setIsPlaying(false);
            }).catch(err => console.error(err));
        } else {
            // Web-based logic
            try {
                if (isiPhone) {
                    pauseAUD();
                    setIsPlaying(false);
                } else {

                    const audioElement = audioRef.current;
                    if (audioElement) {
                        audioElement.pause();
                        audioElement.currentTime = 0;
                        setIsPlaying(false);
                    }
                }
            } catch (error) {
                console.log("🚀 ~ handleStop ~ error:", error)

            }
        }
    };


    const handleSetSpeed = (newSpeedVal) => {
        if (window.cordovaOn) {
            // Cordova-based logic
            audioPlayer.setSpeed(newSpeedVal).then(() => {
                setInitialTempo(newSpeedVal);
                props.setDataNewLpm(lpmFileNum * newSpeedVal);
            }).catch(err => console.error(err));
        } else {
            // Web-based logic
            console.log("🚀 ~ handleSetSpeed ~ newSpeedVal:BF", newSpeedVal)
            if (isiPhone) {
                increaseRateAUD(newSpeedVal);
                setInitialTempo(newSpeedVal);
                props.setDataNewLpm(lpmFileNum * newSpeedVal);
            } else {

                const audioElement = audioRef.current;
                if (audioElement) {
                    console.log("🚀 ~ handleSetSpeed ~ audioElement.playbackRate:", audioElement.playbackRate);
                    newSpeedVal = audioElement.playbackRate + increaseRate;
                    console.log("🚀 ~ newHandleSetSpeed ~ newSpeedVal:AF", newSpeedVal)
                    audioElement.playbackRate = newSpeedVal;
                    setInitialTempo(newSpeedVal);
                    props.setDataNewLpm(lpmFileNum * newSpeedVal);
                }
            }
        }
    };

    useEffect(() => {
        if (isPlaying) {
            setTimeout(() => {
                handleTempo();
            }, 1000);
        }
    }, [isPlaying, initialTempo]);

    const handleTempo = () => {
        let updateTempo = initialTempo + increaseRate;
        handleSetSpeed(updateTempo);
    };

    const onGoBackground = () => {
        console.log("🚀 ~ onGoBackground ~ onGoBackground:", onGoBackground)
        if (window.cordovaOn) {
            setPlay(false);
        } else {

            if (document.visibilityState === 'hidden') {
                console.log("Browser tab is now in the background");
                setPlay(false);
            } else if (document.visibilityState === 'visible') {
                console.log("Browser tab is now in the foreground");
            }
        }
    }

    useEffect(() => {
        document.addEventListener("pause", onGoBackground);
        document.addEventListener("visibilitychange", onGoBackground);
        return (() => {
            console.log("eeffect is off");
            document.removeEventListener("pause", onGoBackground);
            console.log("removing event listener visibilitychange");
            document.removeEventListener("visibilitychange", onGoBackground);
            handleStop();
        })
    }, []);

    return (
        <div>
            {/* Audio element for web */}
            {(!window.cordovaOn && !isiPhone) && (
                <audio ref={audioRef} src={`/audio/wush_${lpmFileNum}_6min.mp3`} preload="auto" />
            )}

            {/* <button onClick={() => { loadSource('../../../../audio/wush_30_6min.mp3'); }}>press</button>
            <button onClick={playAUD}>play</button>
            <button onClick={() => { pauseAUD(is_playing) }}>pause</button>
            <button onClick={() => { increaseRateAUD(0.0008101851851851638) }}>increaseRate</button> */}
        </div>
    );
}

function pickFile(lpm) {
    return lpm < 20 ? 10 : lpm < 60 ? 30 : 80;
}

export default AudioChangeRate;
